import { fetchCveApi } from "@utils";

export const getUserLevelsAccess = async () => {
	let { data, error } = await fetchCveApi({ path: `/temp/getUserLevelAccessV1` });
	return data;
};
